import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { ImgFallbackDirective } from '@banyan/commons/directives/src-fallback.directive';
import { DefaultCurrencyPipe } from '@banyan/commons/pipes/default-currency.pipe';
import { AdminCatalogComponent } from '@banyan/modules/admin/components/catalog/admin-catalog/admin-catalog.component';
import { AdminRequestDetailsComponent } from '@banyan/modules/admin/components/request/admin-request-details/admin-request-details.component';
import { BadgeComponent } from '@banyan/modules/standalone/badge/badge.component';
import { GradientComponent } from '@banyan/modules/standalone/gradient/gradient.component';
import { PaginationComponent } from '@banyan/modules/standalone/pagination/pagination.component';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../shared/shared.module';
import { ButtonComponent } from '../standalone/button/button.component';
import { ChipComponent } from '../standalone/chip/chip.component';
import { FeedbackPanelComponent } from '../standalone/feedback-panel/feedback-panel.component';
import { AdminRoutingModule } from './admin.routing.module';
import { AdminLayoutComponent } from './components/admin-layout/admin-layout.component';
import { AdminNavbarComponent } from './components/admin-navbar/admin-navbar.component';
import { AdminProductCardComponent } from './components/request/admin-product-card/admin-product-card.component';
import { AdminRequestDetailModalComponent } from './components/request/admin-request-detail-modal/admin-request-detail-modal.component';
import { AdminRequestsComponent } from './components/request/admin-requests/admin-requests.component';


@NgModule({
  declarations: [AdminLayoutComponent, AdminNavbarComponent, AdminRequestsComponent, AdminRequestDetailsComponent, AdminRequestDetailModalComponent, AdminProductCardComponent, AdminCatalogComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTabsModule,
    MatFormField,
    MatLabel,
    MatInputModule,
    AdminRoutingModule,
    TranslateModule,
    ChipComponent,
    ButtonComponent,
    GradientComponent,
    BadgeComponent,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    FormsModule,
    MatMenuTrigger,
    MatMenu,
    SharedModule,
    DefaultCurrencyPipe,
    FeedbackPanelComponent,
    ImgFallbackDirective,
    PaginationComponent,
  ],
})
export class AdminModule {
}
